var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trip-route-travel-dot-connection-relationship",
    style: {
      enableBackground: "new 0 0 15 13"
    },
    viewBox: "0 0 15 13",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,10c-0.651,0-1.201,0.419-1.408,1H3c-1.103,0-2-0.897-2-2s0.897-2,2-2h9c1.654,0,3-1.346,3-3s-1.346-3-3-3H2.908  C2.701,0.419,2.151,0,1.5,0C0.673,0,0,0.673,0,1.5S0.673,3,1.5,3c0.651,0,1.201-0.419,1.408-1H12c1.103,0,2,0.897,2,2s-0.897,2-2,2  H3C1.346,6,0,7.346,0,9s1.346,3,3,3h9.092c0.207,0.581,0.757,1,1.408,1c0.827,0,1.5-0.673,1.5-1.5S14.327,10,13.5,10z M1.5,2  C1.224,2,1,1.776,1,1.5S1.224,1,1.5,1S2,1.224,2,1.5S1.776,2,1.5,2z M13.5,12c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5  s0.5,0.224,0.5,0.5S13.776,12,13.5,12z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/Route.bc72c1bb.svg";
export { ForwardRef as ReactComponent };